<template>
  <el-button
    :class="['global__button-black', size]"
    :disabled="isDisabled"
    v-on="$listeners"
  >
    <i v-if="loading" class="el-icon-loading" />
    <slot />
  </el-button>
</template>

<script>
export default {
  name: 'AdsButton',
  props: {
    // Possible size:
    // + small
    // + medium (default)
    // + large
    size: {
      type: String,
      default: 'medium',
    },
    // Possible variant:
    // + default
    // + primary
    // + secondary
    // + tertiary
    // + outlined
    // + text
    variant: {
      type: String,
      default: 'default',
    },
    // Make default button type as button
    // (by browser default, button type is submit, which is not commonly used in this project)
    type: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDisabled() {
      return this.$attrs.disabled || this.loading
    },
  },
}
</script>

<style lang="scss" scoped>
.el-icon-loading {
  margin-inline-end: 8px;

  .large & {
    margin-inline-end: 12px;
  }

  .small & {
    margin-inline-end: 4px;
  }
}
</style>

<style lang="scss">
.ads-common-button {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #fff;
  background: #212442;
  border-color: #212442;
  border-width: 1px;
  border-radius: 9999px;

  &.primary {
    color: #fff;
    background: #8800e3;
    border-color: #8800e3;

    &:hover,
    &:focus-visible {
      background: #7a06c3;
      border-color: #7a06c3;
    }

    &:active {
      background: #65079c;
      border-color: #65079c;
    }

    &:disabled {
      color: #dea5ff;
      background: #fbf3ff;
      border-color: #fbf3ff;
    }
  }

  &.secondary {
    color: #5f6587;
    background: #f5f5ff;
    border-color: #f5f5ff;
  }

  &.tertiary {
    color: #5f6587;
    background: none;
    border: none;
  }

  &.outlined {
    color: #5f6587;
    background: #fff;
    border-color: #e0e0ed;
  }

  &.text {
    color: #5f6587;
    text-decoration: underline;
    text-underline-offset: 4px;
    background: transparent;
    border-color: transparent;

    &:disabled {
      color: #949abf;
      cursor: not-allowed;
    }
  }

  &.small {
    font-size: 14px;
    font-weight: 500;
  }

  &:not(.text, .primary):disabled {
    color: #949abf;
    cursor: not-allowed;
    background: #f5f5ffb8;
    border-color: #f5f5ffb8;
  }

  &:focus-visible {
    outline: 2px solid #5d00ba;
    outline-offset: 2px;
  }

  &.rounded {
    border-radius: 9999px;
  }

  &.normal {
    border-radius: 8px;
  }
}

.ads-common-button:not(.text) {
  padding-block: 12px;
  padding-inline: 24px;

  &.small {
    padding-block: 6px;
    padding-inline: 16px;
  }

  &.large {
    padding-block: 16px;
    padding-inline: 24px;
  }
}

.global__button-black {
  &.small {
    padding-block: 6px;
    padding-inline: 16px;
  }
}
</style>
